import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'services/store/ai';
import { selectUploadedAudio } from 'services/store/ai/selectors';
import { FormulaFields } from 'services/store/ai/types';
import FormulaItemContainer from 'pages/AIMusicGenerator/components/FormulaEditor/components/FormulaItemContainer';
import FormulaItem from 'pages/AIMusicGenerator/components/FormulaItem';

const field = FormulaFields.UserLoop;

const TextToMusicLoopField = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const uploadedAudioField = useSelector(selectUploadedAudio);

  if (!uploadedAudioField) {
    return null;
  }

  return (
    <FormulaItemContainer
      label={t(`aiMusicGenerator:formulaFieldLabels:${field}`)}
      onClose={() => dispatch(actions.deleteFormulaField({ field }))}
    >
      <FormulaItem field={uploadedAudioField} />
    </FormulaItemContainer>
  );
};

export default TextToMusicLoopField;
